module.exports = {
	"articleTitle1": "Viewpoint: The 'Rundown' Languages Building",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "Modern Languages Building (MLB)",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/content/leap-faith",
	"articleSnippet1": "Jan 13, 2014 ... Let's renovate the MLB, already. ... nestled in the basement of the Modern \nLanguages Building, my French class glanced from the clock to the ...",
	"articleSnippet2": "Oct 26, 2005 ... ... which meets in the Modern Languages Building every Sunday. ... MLB 3 \nbecomes the meeting place for New Life members to praise God.",
	"totalMisc": 0,
	"articleTitle2": "Leap of faith",
	"address": "812 E Washington St #4108, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/161117/jam.NEW_.DiagNightMarch.11.15.16.654%20copy.jpg?itok=H2Qiw3XU",
			"author": "Carolyn Gearig",
			"caption": "Two hundred students gathered in the MLB on Tuesday night as CSG debated a resolution that called on the University to divest its investments in several companies that allegedly commit human rights violations against Palestinians."
		}
	],
	"position": {
		"lat": 42.279813,
		"lng": -83.739158
	},
	"tips": [
		{
			"text": "The hallways are usually pretty quiet and the benches are a great place to catch up on some reading.",
			"person": "Nick Kortman"
		},
		{
			"text": "This is a pretty ugly building, not gonna lie.",
			"person": "Erik Forkin"
		}
	],
	"bathroomrating": [
		{
			"rating": 1,
			"bathroom": "Ladies restroom 1st floor"
		}
	],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/mlb.json
// module id = 925
// module chunks = 0